import { Button } from "primereact/button";
import { Chart } from "primereact/chart";
import { InputNumber } from "primereact/inputnumber";
import { Panel } from "primereact/panel";

import ChartDataLabels from "chartjs-plugin-datalabels";
import annotationPlugin from "chartjs-plugin-annotation";

export function MetragemDiaTurmas({ data, value, setValue, handlePrint, name, printing, total }) {
    var options = {
        maintainAspectRatio: false,
        parsing: {
            yAxisKey: 'x'
        },
        plugins: {
            title: {
                display: true,
                text: `Gráfico de Metragem - ${data.periodo}`,
                font: {
                    size: 24,
                },
            },
            subtitle: {
                display: true,
                text: `Total - ${Intl.NumberFormat("pt-BR").format(total)}m  /  Meta: ${Intl.NumberFormat("pt-BR").format(value)}m`,
                font: {
                    size: 24,
                },
            },
            legend: {
                labels: {
                    color: "#000"
                }
            },
            annotation: {
                annotations: {
                    line1: {
                        type: "line",
                        yMin: value !== null ? value : 0,
                        yMax: value !== null ? value : 0,
                        borderColor: "#2980b9",
                        borderWidth: 2,
                    },
                },
            },
            datalabels: {
                anchor: name !== "dados" ? "center" : "end",
                align: name !== "dados" ? "center" : "end",
                rotation: -90,
                formatter: (object, ctx) => {
                    if (ctx.dataset.label === "Meta") {
                        return "";
                    }
                    return Intl.NumberFormat("pt-BR", {
                        maximumFractionDigits: 2,
                    }).format(object.x) + " - " + Intl.NumberFormat('pt-BR', { maximumFractionDigits: 2 }).format(object.eficiencia) + "%";
                },
                font: {
                    size: printing ? 20 : 24,
                },
                color: "#2c3e50",
            },
        },
        scales: {
            x: {
                ticks: {
                    font: {
                        size: 16
                    },
                    color: "#000"
                }
            },
            y: {
                max: name === "dados" ?  data.max + 8000 : 100,
            },
        },
    }

    return (
        <Panel header="GRÁFICO DE METRAGEM POR TURNO" toggleable collapsed={true}>
            <div>
                <Button
                    className="p-m-2"
                    icon="pi pi-print"
                    onClick={() => handlePrint("chartMetragem4")}
                />
                <InputNumber
                    className="p-m-2"
                    onChange={(e) => setValue(e.value)}
                    value={value}
                />
            </div>
            <Chart
                id="chartMetragem4"
                height={printing ? "210mm" : "650px"}
                width={printing ? "297mm" : "100%"}
                type="bar"
                data={data[name]}
                options={options}
                plugins={[ChartDataLabels, annotationPlugin]}
            />
        </Panel>
    )
}

